import { render } from "./UsersStats.vue?vue&type=template&id=6965e94d&scoped=true"
import script from "./UsersStats.vue?vue&type=script&lang=js"
export * from "./UsersStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6965e94d"]])

export default __exports__